// DEA — traido de dan_branch el 2026-09-08.
var isMobile = false;
 if( /Android|webOS|iPhone|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || document.documentElement.clientWidth <= 769 ) {
    isMobile = true;
}
$(document).ready(function() {
 	var urlParams = new URLSearchParams(window.location.search);
 	var emailFromURL = urlParams.get('email');
 	var origenValue = urlParams.get('origen');

  if (!origenValue) {
  var pathname = window.location.pathname;

  if (pathname === "/pages/mega-venta") {
    origenValue = "megaventa";
  }
}
  
 	if (origenValue) $("#origen").val(origenValue);
 	if (emailFromURL) $('#email').val(emailFromURL);
 	var formData = {
 		email: emailFromURL,
 		tipo: origenValue
 	};
 	$.ajax({
 		type: "POST",
 		url: "https://dev.socialpro.mx/ne_klaviyo/get_profile2.php",
 		data: formData,
 		dataType: 'json',
 		success: function(response) {
 			console.log(response);
 			if (response.accion == 'Nuevo') {
 				console.log('Nuevo')
 			} else {
               $('.txt-actualiza').css('display','block');
                if(response.properties.Género == 'Masculino'){
                  $('#masculino').prop('checked', true);
                } 
                if(response.properties.Género == 'Indistinto'){
                  $('#indistinto').prop('checked', true);
                }               
 				futTeams = response.properties.Fútbol;
                console.log(futTeams);
 				lmbTeams = response.properties.LMB;
 				mlbTeams = response.properties.MLB;
 				nbaTeams = response.properties.NBA;
 				nflTeams = response.properties.NFL;
 				dmTeams = response.properties.Deporte_motor;
 				var futTeams = futTeams.split(',');
 				var lmbTeams = lmbTeams.split(',');
 				var mlbTeams = mlbTeams.split(',');
 				var nbaTeams = nbaTeams.split(',');
 				var nflTeams = nflTeams.split(',');
 				var dmTeams = dmTeams.split(',');
                var zip = response.location.zip;
                var age = response.properties.Age;   
                $('#zip').val(zip);              
                $('#cumple').val(age);                          
 				$('.log').each(function() {
 					var valor = $(this).val();                    
 					if ($.inArray(valor, futTeams) !== -1) {
 						$(this).prop('checked', true);
 					}
 				});
 				$('.log').each(function() {
 					var valor = $(this).val();
 					if ($.inArray(valor, lmbTeams) !== -1) {
 						$(this).prop('checked', true);
 					}
 				});
 				$('.log').each(function() {
 					var valor = $(this).val();
 					if ($.inArray(valor, mlbTeams) !== -1) {
 						$(this).prop('checked', true);
 					}
 				});
 				$('.log').each(function() {
 					var valor = $(this).val();
 					if ($.inArray(valor, nbaTeams) !== -1) {
 						$(this).prop('checked', true);
 					}
 				});
 				$('.log').each(function() {
 					var valor = $(this).val();
 					if ($.inArray(valor, nflTeams) !== -1) {
 						$(this).prop('checked', true);
 					}
 				});
 				$('.log').each(function() {
 					var valor = $(this).val();
 					if ($.inArray(valor, dmTeams) !== -1) {
 						$(this).prop('checked', true);
 					}
 				});
 			}
 		},
 		error: function(error) {
 			alert("Error:", error);
 		}
 	});
 });
 document.addEventListener("DOMContentLoaded", function() {
 	var tabsData = [{
 		id: 1,
 		title: "MLB",
        img: "https://cdn.shopify.com/s/files/1/0595/9915/9452/files/slide-mlb.png?v=1725483824",
        imgName: "https://cdn.shopify.com/s/files/1/0595/9915/9452/files/MLB_96e8ac66-09fe-48c3-a106-5a4809f36f3c.png?v=1720800893",
 		content: [{
 			"id": "yankees",
 			"nombre": "Yankees",
 			"liga": "mlb[]"
 		}, {
 			"id": "red-sox",
 			"nombre": "Red Sox",
 			"liga": "mlb[]"
 		}, {
 			"id": "dodgers",
 			"nombre": "Dodgers",
 			"liga": "mlb[]"
 		}, {
 			"id": "cubs",
 			"nombre": "Cubs",
 			"liga": "mlb[]"
 		}, {
 			"id": "blue-jays",
 			"nombre": "Blue Jays",
 			"liga": "mlb[]"
 		}, {
 			"id": "giants-m",
 			"nombre": "Giants",
 			"liga": "mlb[]"
 		}, {
 			"id": "angels",
 			"nombre": "Angels",
 			"liga": "mlb[]"
 		}, {
 			"id": "astros",
 			"nombre": "Astros",
 			"liga": "mlb[]"
 		}, {
 			"id": "athletics",
 			"nombre": "Athletics",
 			"liga": "mlb[]"
 		}, {
 			"id": "rays",
 			"nombre": "Rays",
 			"liga": "mlb[]"
 		}, {
 			"id": "braves",
 			"nombre": "Braves",
 			"liga": "mlb[]"
 		}, {
 			"id": "brewers",
 			"nombre": "Brewers",
 			"liga": "mlb[]"
 		}, {
 			"id": "cardinals-m",
 			"nombre": "Cardinals",
 			"liga": "mlb[]"
 		}, {
 			"id": "diamondbacks",
 			"nombre": "Diamondbacks",
 			"liga": "mlb[]"
 		}, {
 			"id": "indians",
 			"nombre": "Indians",
 			"liga": "mlb[]"
 		}, {
 			"id": "mariners",
 			"nombre": "Mariners",
 			"liga": "mlb[]"
 		}, {
 			"id": "marlins",
 			"nombre": "Marlins",
 			"liga": "mlb[]"
 		}, {
 			"id": "mets",
 			"nombre": "Mets",
 			"liga": "mlb[]"
 		}, {
 			"id": "nationals",
 			"nombre": "Nationals",
 			"liga": "mlb[]"
 		}, {
 			"id": "orioles",
 			"nombre": "Orioles",
 			"liga": "mlb[]"
 		}, {
 			"id": "padres",
 			"nombre": "Padres",
 			"liga": "mlb[]"
 		}, {
 			"id": "phillies",
 			"nombre": "Phillies",
 			"liga": "mlb[]"
 		}, {
 			"id": "pirates",
 			"nombre": "Pirates",
 			"liga": "mlb[]"
 		}, {
 			"id": "rangers",
 			"nombre": "Rangers",
 			"liga": "mlb[]"
 		}, {
 			"id": "reds",
 			"nombre": "Reds",
 			"liga": "mlb[]"
 		}, {
 			"id": "rockies",
 			"nombre": "Rockies",
 			"liga": "mlb[]"
 		}, {
 			"id": "royals",
 			"nombre": "Royals",
 			"liga": "mlb[]"
 		}, {
 			"id": "tigers",
 			"nombre": "Tigers",
 			"liga": "mlb[]"
 		}, {
 			"id": "twins",
 			"nombre": "Twins",
 			"liga": "mlb[]"
 		}, {
 			"id": "white-sox",
 			"nombre": "White Sox",
 			"liga": "mlb[]"
 		}]
 	}, {
 		id: 2,
 		title: "NFL",
        img: "https://cdn.shopify.com/s/files/1/0595/9915/9452/files/slide-nfl.png?v=1725483824",   
        imgName: "https://cdn.shopify.com/s/files/1/0595/9915/9452/files/NFL_eaca2471-a80a-4206-8b02-f3f2c0011fad.png?v=1720800893",
 		content: [{
 			"id": "cowboys",
 			"nombre": "Cowboys",
 			"liga": "nfl[]"
 		}, {
 			"id": "sfers",
 			"nombre": "49ers",
 			"liga": "nfl[]"
 		}, {
 			"id": "raiders",
 			"nombre": "Raiders",
 			"liga": "nfl[]"
 		}, {
 			"id": "steelers",
 			"nombre": "Steelers",
 			"liga": "nfl[]"
 		}, {
 			"id": "patriotas",
 			"nombre": "Patriots",
 			"liga": "nfl[]"
 		}, {
 			"id": "broncos",
 			"nombre": "Broncos",
 			"liga": "nfl[]"
 		}, {
 			"id": "seahawks",
 			"nombre": "Seahawks",
 			"liga": "nfl[]"
 		}, {
 			"id": "packers",
 			"nombre": "Packers",
 			"liga": "nfl[]"
 		}, {
 			"id": "bears",
 			"nombre": "Bears",
 			"liga": "nfl[]"
 		}, {
 			"id": "bengals",
 			"nombre": "Bengals",
 			"liga": "nfl[]"
 		}, {
 			"id": "bills",
 			"nombre": "Bills",
 			"liga": "nfl[]"
 		}, {
 			"id": "browns",
 			"nombre": "Browns",
 			"liga": "nfl[]"
 		}, {
 			"id": "buccaneers",
 			"nombre": "Buccaneers",
 			"liga": "nfl[]"
 		}, {
 			"id": "cardinals",
 			"nombre": "Cardinals",
 			"liga": "nfl[]"
 		}, {
 			"id": "chargers",
 			"nombre": "Chargers",
 			"liga": "nfl[]"
 		}, {
 			"id": "chiefs",
 			"nombre": "Chiefs",
 			"liga": "nfl[]"
 		}, {
 			"id": "colts",
 			"nombre": "Colts",
 			"liga": "nfl[]"
 		}, {
 			"id": "dolphins",
 			"nombre": "Dolphins",
 			"liga": "nfl[]"
 		}, {
 			"id": "eagles",
 			"nombre": "Eagles",
 			"liga": "nfl[]"
 		}, {
 			"id": "falcons",
 			"nombre": "Falcons",
 			"liga": "nfl[]"
 		}, {
 			"id": "giants",
 			"nombre": "Giants",
 			"liga": "nfl[]"
 		}, {
 			"id": "jaguars",
 			"nombre": "Jaguars",
 			"liga": "nfl[]"
 		}, {
 			"id": "jets",
 			"nombre": "Jets",
 			"liga": "nfl[]"
 		}, {
 			"id": "lions",
 			"nombre": "Lions",
 			"liga": "nfl[]"
 		}, {
 			"id": "panthers",
 			"nombre": "Panthers",
 			"liga": "nfl[]"
 		}, {
 			"id": "rams",
 			"nombre": "Rams",
 			"liga": "nfl[]"
 		}, {
 			"id": "ravens",
 			"nombre": "Ravens",
 			"liga": "nfl[]"
 		}, {
 			"id": "redskins",
 			"nombre": "Redskins",
 			"liga": "nfl[]"
 		}, {
 			"id": "saints",
 			"nombre": "Saints",
 			"liga": "nfl[]"
 		}, {
 			"id": "texans",
 			"nombre": "Texans",
 			"liga": "nfl[]"
 		}, {
 			"id": "titans",
 			"nombre": "Titans",
 			"liga": "nfl[]"
 		}, {
 			"id": "vikings",
 			"nombre": "Vikings",
 			"liga": "nfl[]"
 		}]
 	}, {
 		id: 3,
 		title: "NBA",
        img: "https://cdn.shopify.com/s/files/1/0595/9915/9452/files/slide-nba.png?v=1725483824",    
        imgName: "https://cdn.shopify.com/s/files/1/0595/9915/9452/files/NBA_ffc02410-659d-48c8-8be5-0aed8527a990.png?v=1720800893",
 		content: [{
 			"id": "spurs",
 			"nombre": "Spurs",
 			"liga": "nba[]"
 		}, {
 			"id": "warriors",
 			"nombre": "Warriors",
 			"liga": "nba[]"
 		}, {
 			"id": "celtics",
 			"nombre": "Celtics",
 			"liga": "nba[]"
 		}, {
 			"id": "lakers",
 			"nombre": "Lakers",
 			"liga": "nba[]"
 		}, {
 			"id": "bulls",
 			"nombre": "Bulls",
 			"liga": "nba[]"
 		}, {
 			"id": "cavaliers",
 			"nombre": "Cavaliers",
 			"liga": "nba[]"
 		}, {
 			"id": "ssers",
 			"nombre": "76ers",
 			"liga": "nba[]"
 		}, {
 			"id": "clippers",
 			"nombre": "Clippers",
 			"liga": "nba[]"
 		}, {
 			"id": "grizzlies",
 			"nombre": "Grizzlies",
 			"liga": "nba[]"
 		}, {
 			"id": "hawks",
 			"nombre": "Hawks",
 			"liga": "nba[]"
 		}, {
 			"id": "heat",
 			"nombre": "Heat",
 			"liga": "nba[]"
 		}, {
 			"id": "hornets",
 			"nombre": "Hornets",
 			"liga": "nba[]"
 		}, {
 			"id": "jazz",
 			"nombre": "Jazz",
 			"liga": "nba[]"
 		}, {
 			"id": "kings",
 			"nombre": "Kings",
 			"liga": "nba[]"
 		}, {
 			"id": "knicks",
 			"nombre": "Knicks",
 			"liga": "nba[]"
 		}, {
 			"id": "magic",
 			"nombre": "Magic",
 			"liga": "nba[]"
 		}, {
 			"id": "mavericks",
 			"nombre": "Mavericks",
 			"liga": "nba[]"
 		}, {
 			"id": "nets",
 			"nombre": "Nets",
 			"liga": "nba[]"
 		}, {
 			"id": "nuggets",
 			"nombre": "Nuggets",
 			"liga": "nba[]"
 		}, {
 			"id": "pacers",
 			"nombre": "Pacers",
 			"liga": "nba[]"
 		}, {
 			"id": "pelicans",
 			"nombre": "Pelicans",
 			"liga": "nba[]"
 		}, {
 			"id": "pistons",
 			"nombre": "Pistons",
 			"liga": "nba[]"
 		}, {
 			"id": "raptors",
 			"nombre": "Raptors",
 			"liga": "nba[]"
 		}, {
 			"id": "rockets",
 			"nombre": "Rockets",
 			"liga": "nba[]"
 		}, {
 			"id": "suns",
 			"nombre": "Suns",
 			"liga": "nba[]"
 		}, {
 			"id": "thunder",
 			"nombre": "Thunder",
 			"liga": "nba[]"
 		}, {
 			"id": "timberwolves",
 			"nombre": "Timberwolves",
 			"liga": "nba[]"
 		}, {
 			"id": "trail-blazers",
 			"nombre": "Trail Blazers",
 			"liga": "nba[]"
 		}, {
 			"id": "wizards",
 			"nombre": "Wizards",
 			"liga": "nba[]"
 		}, {
 			"id": "milwaukee",
 			"nombre": "Milwaukee",
 			"liga": "nba[]"
 		}]
 	}, {
 		id: 4,
 		title: "BEISBOL_MEXICANO",
        img: "https://cdn.shopify.com/s/files/1/0595/9915/9452/files/slide-beisbol-mexicano.png?v=1725483824",    
        imgName: "https://cdn.shopify.com/s/files/1/0595/9915/9452/files/BEISBOL_MEXICANO_560dbde5-6ff6-4e49-bcd7-774e1e316e33.png?v=1720800893",
 		content: [{
 			"id": "acereros",
 			"nombre": "Acereros",
 			"liga": "lmb[]"
 		}, {
 			"id": "bravos-leon",
 			"nombre": "Bravos",
 			"liga": "lmb[]"
 		}, {
 			"id": "diablos",
 			"nombre": "Diablos",
 			"liga": "lmb[]"
 		}, {
 			"id": "generales",
 			"nombre": "Generales",
 			"liga": "lmb[]"
 		}, {
 			"id": "guerreros",
 			"nombre": "Guerreros",
 			"liga": "lmb[]"
 		}, {
 			"id": "leones",
 			"nombre": "Leones",
 			"liga": "lmb[]"
 		}, {
 			"id": "olmecas",
 			"nombre": "Olmecas",
 			"liga": "lmb[]"
 		}, {
 			"id": "pericos",
 			"nombre": "Pericos",
 			"liga": "lmb[]"
 		}, {
 			"id": "piratas",
 			"nombre": "Piratas",
 			"liga": "lmb[]"
 		}, {
 			"id": "rieleros",
 			"nombre": "Rieleros",
 			"liga": "lmb[]"
 		}, {
 			"id": "saraperos",
 			"nombre": "Saraperos",
 			"liga": "lmb[]"
 		}, {
 			"id": "sultanes",
 			"nombre": "Sultanes",
 			"liga": "lmb[]"
 		}, {
 			"id": "tecolotes",
 			"nombre": "Tecolotes",
 			"liga": "lmb[]"
 		}, {
 			"id": "tigres-lmb",
 			"nombre": "Tigres",
 			"liga": "lmb[]"
 		}, {
 			"id": "toros",
 			"nombre": "Toros",
 			"liga": "lmb[]"
 		}, {
 			"id": "laguna",
 			"nombre": "Laguna",
 			"liga": "lmb[]"
 		}, {
 			"id": "veracruz",
 			"nombre": "Veracruz",
 			"liga": "lmb[]"
 		}, {
 			"id": "mariachis",
 			"nombre": "Mariachis",
 			"liga": "lmb[]"
 		}, {
 			"id": "aguilas-lmp",
 			"nombre": "Aguilas",
 			"liga": "lmb[]"
 		}, {
 			"id": "caneros",
 			"nombre": "Cañeros",
 			"liga": "lmb[]"
 		}, {
 			"id": "charros",
 			"nombre": "Charros",
 			"liga": "lmb[]"
 		}, {
 			"id": "naranjeros",
 			"nombre": "Naranjeros",
 			"liga": "lmb[]"
 		}, {
 			"id": "tomateros",
 			"nombre": "Tomateros",
 			"liga": "lmb[]"
 		}, {
 			"id": "yaquis",
 			"nombre": "Yaquis",
 			"liga": "lmb[]"
 		}, {
 			"id": "algodoneros",
 			"nombre": "Algodoneros",
 			"liga": "lmb[]"
 		}, {
 			"id": "mayas_n",
 			"nombre": "Mayas_n",
 			"liga": "lmb[]"
 		}, {
 			"id": "dorados",
 			"nombre": "Dorados",
 			"liga": "lmb[]"
 		}, {
 			"id": "conspiradores",
 			"nombre": "Conspiradores",
 			"liga": "lmb[]"
 		}]
 	}, {
 		id: 5,
 		title: "FUTBOL",
        img: "https://cdn.shopify.com/s/files/1/0595/9915/9452/files/slide-futbol.png?v=1725483824",
        imgName: "https://cdn.shopify.com/s/files/1/0595/9915/9452/files/FUTBOL_3118a301-2417-4354-a5e7-4d2a80d20e09.png?v=1720800893",
 		content: [{
 			"id": "america",
 			"nombre": "America",
 			"liga": "futbol[]"
 		}, {
 			"id": "chivas",
 			"nombre": "Chivas",
 			"liga": "futbol[]"
 		}, {
 			"id": "cazul",
 			"nombre": "Cruz Azul",
 			"liga": "futbol[]"
 		}, {
 			"id": "rayados",
 			"nombre": "Rayados",
 			"liga": "futbol[]"
 		}, {
 			"id": "pumas",
 			"nombre": "Pumas",
 			"liga": "futbol[]"
 		}, {
 			"id": "tigres",
 			"nombre": "Tigres",
 			"liga": "futbol[]"
 		}, {
 			"id": "pachuca",
 			"nombre": "Club Pachuca",
 			"liga": "futbol[]"
 		}, {
 			"id": "santos",
 			"nombre": "Santos",
 			"liga": "futbol[]"
 		}, {
 			"id": "xolos",
 			"nombre": "Xolos",
 			"liga": "futbol[]"
 		}, {
 			"id": "gallos",
 			"nombre": "Gallos",
 			"liga": "futbol[]"
 		}, {
 			"id": "puebla",
 			"nombre": "Puebla",
 			"liga": "futbol[]"
 		}, {
 			"id": "cleon",
 			"nombre": "Club Leon",
 			"liga": "futbol[]"
 		}, {
 			"id": "toluca",
 			"nombre": "Toluca",
 			"liga": "futbol[]"
 		}, {
 			"id": "atlas",
 			"nombre": "Atlas",
 			"liga": "futbol[]"
 		}, {
 			"id": "necaxa",
 			"nombre": "Necaxa",
 			"liga": "futbol[]"
 		}/*, {
 			"id": "mazatlan",
 			"nombre": "Mazatlán",
 			"liga": "futbol[]"
 		}*/]
 	}, {
 		id: 6,
 		title: "DEPORTE_MOTOR",
        img: "https://cdn.shopify.com/s/files/1/0595/9915/9452/files/slide-deporte-motor.png?v=1725483824",      
        imgName: "https://cdn.shopify.com/s/files/1/0595/9915/9452/files/DEPORTE_MOTOR_1128311a-b3e7-4efc-9bc9-57208902ee81.png?v=1720800893",
 		content: [{
 			"id": "red-bull",
 			"nombre": "Red Bull",
 			"liga": "auto[]"
 		}, {
 			"id": "mclaren",
 			"nombre": "McLaren",
 			"liga": "auto[]"
 		}, {
 			"id": "ducati",
 			"nombre": "Ducati",
 			"liga": "auto[]"
 		}, {
 			"id": "alpine",
 			"nombre": "Alpine",
 			"liga": "auto[]"
 		}, {
 			"id": "haas",
 			"nombre": "Haas",
 			"liga": "auto[]"
 		}, {
 			"id": "aprilia",
 			"nombre": "Aprilia",
 			"liga": "auto[]"
 		}]
 	}, {
 		id: 7,
 		title: "MODA",
        img: "https://cdn.shopify.com/s/files/1/0595/9915/9452/files/slide-moda.png?v=1725483824",
        imgName: "https://cdn.shopify.com/s/files/1/0595/9915/9452/files/MODA_d2f0b037-1e5d-410c-ab8f-f61fc8a657fa.png?v=1721079031",      
 		content: [{
 			"id": "moda",
 			"nombre": "Moda",
 			"liga": "moda[]"
 		}]
 	}];
   
    Handlebars.registerHelper('ismoda', function (value) {
      return value === 'moda';
    });   
    if (!isMobile) {      
     	var tabsTemplate = Handlebars.compile(document.getElementById("slide-template").innerHTML);
     	document.getElementById("slide").innerHTML = tabsTemplate({
     		tabs: tabsData
     	}); 	
	      
    } else { 	
 	var panesTemplate = Handlebars.compile(document.getElementById("acordeon-template").innerHTML);
 	document.getElementById("acordeon-movil").innerHTML = panesTemplate({
 		tabs: tabsData
 	});      
      
    }

    var tabsTemplate = Handlebars.compile(document.getElementById("popup-template").innerHTML);
    document.getElementById("popups").innerHTML = tabsTemplate({
    	tabs: tabsData
    });    
 });


 (function($) {

  $('input').on('keypress', function() {
       $(this).removeClass('error');
  });

   $('#cumple').on('change', function() {
        $(this).removeClass('error');
    });


    $('input[name="contact[note][genero]"]').on('change', function() {
        if ($('input[name="contact[note][genero]"]:checked').length > 0) {
            $('#elgenero').removeClass('invalid');
        }
    });
   
  function isValidEmail(email) {
    // Expresión regular para validar el correo electrónico
    var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  function isValidZip(zip) {
    // Expresión regular para validar el código postal (solo dígitos y longitud de 5)
    var zipRegex = /^\d{5}$/;
    return zipRegex.test(zip);
  }

   

  function isValidDate(date) {
    // Verificar si se ingresó una fecha válida (no está vacía)
    return !!date;
  }   
 	$(function() {

 $("#update").click(function() {
  $("input").removeClass('error');
   $("#error").html('');   
    var email = $('#email').val();
    var zip = $('#zip').val();
    var cumple = $('#cumple').val();
    var isValid = true;
   
    // Validación de correo electrónico
    if (!isValidEmail(email)) {
      $('#email').addClass('error');
      isValid = false;
    } else {
      $('#email').removeClass('error');
    }

    // Validación de código postal
    if (!isValidZip(zip)) {
      $('#zip').addClass('error');
      isValid = false;
    } else {
      $('#zip').removeClass('error');
    }

    // Validación de fecha de nacimiento
    if (!isValidDate(cumple)) {
      $('#cumple').addClass('error');
      isValid = false;
    } else {
      $('#cumple').removeClass('error');
    }

    if ($('input[name="contact[note][genero]"]:checked').length > 0) {
        
    } else {
        console.log('Ninguno está seleccionado.');
         isValid = false;      
        $('#elgenero').addClass('invalid');
    }

    var equipoc = $('.log:checked').length;

    if (equipoc < 1) {
      console.log('Elige un equipo');
      isValid = false;
      $("#error_c").html('<p class="txt-error">Debes elegir un equipo.</p>');
    } else {
      console.log('Ningún equipo está seleccionado.');
      $("#error_c").html('');
    }
   

    // Si todos los campos son válidos
    if (isValid) {
      console.log(1);
      
           $('.message').html('<span>Estamos registrando sus datos...</span>')

        $('.message span').fadeOut(500, function(){
            $(this).fadeIn(500, function(){
                blink(); // Llamada recursiva para continuar el parpadeo
            });
        });      
 			var formData = {
 				email: $('#email').val(),
 				zip: $("#zip").val(),
                origen: $("#origen").val(),
 				cumple: $("input[name='contact[note][cumple]']").val(),
 				genero: $("input[name='contact[note][genero]']:checked").val(),
 				moda: $("input[name='moda']:checked").val(),              
 				futbol: $("input[name='futbol[]']:checked").map(function() {
 					return $(this).val();
 				}).get().join(','),
 				mlb: $("input[name='mlb[]']:checked").map(function() {
 					return $(this).val();
 				}).get().join(','),
 				lmb: $("input[name='lmb[]']:checked").map(function() {
 					return $(this).val();
 				}).get().join(','),
 				nfl: $("input[name='nfl[]']:checked").map(function() {
 					return $(this).val();
 				}).get().join(','),
 				nba: $("input[name='nba[]']:checked").map(function() {
 					return $(this).val();
 				}).get().join(','),
 				auto: $("input[name='auto[]']:checked").map(function() {
 					return $(this).val();
 				}).get().join(',')
 			};
 			console.log(formData);
 			$.ajax({
 				type: 'POST',
 				url: 'https://dev.socialpro.mx/ne_klaviyo/create_or_update_v2.php',
 				data: formData,
 				success: function(response) {   
                    var queryString = window.location.search;
                    var url_equipo = new URLSearchParams(queryString);
                    var equipo = url_equipo.get('origen');   
                    if (equipo == 'upgrade-cupon') { 
                      window.location.href = "https://www.newera.mx/pages/gracias-cupon";
                    } else {
                         window.location.href = "https://www.newera.mx/pages/gracias-por-suscribirte";
                    }
 				},
 				error: function(error) {
 					console.error('Error al enviar los datos', error);
 				}
 			});
      } else {
        $("#error").html('<p class="txt-error">Existen campos inválidos.</p>');
        }          
 	});
 	});
 	$('#fan-todo').change(function() {
 		var isChecked = $(this).prop('checked');
 		if (isChecked) {
 			$('input[type="checkbox"]').prop('checked', true);
 		} else {
 			$('input[type="checkbox"]').prop('checked', false);
 		}
 	});
 })(jQuery);

$(document).ready(function() { 
    var queryString = window.location.search;
    var url_equipo = new URLSearchParams(queryString);
    var equipo = url_equipo.get('origen');
    if (equipo == 'upgrade-cupon') {           
        const currentUrl = window.location.href;              
        if (currentUrl.includes("?origen=upgrade-cupon")) {            
            const redirectUrl = currentUrl.split("?")[0]; 
            window.location.href = redirectUrl;
        }      
      /*$('h1').html('ACTUALIZA TUS PREFERENCIAS Y RECIBE UN CUPÓN DE ENVÍO GRATIS');      
      $('h1').css('font-size','28px');      
      $('.cont-fan').css('visibility','hidden');  */
    }
    if (equipo == 'cruz_azul') {
      setTimeout(function() {
        
        $('.nav-link.active').removeClass('active');
        $('.tab-pane.fade.active.show').removeClass('active show');
        
        $('#tab5').addClass('active');
        $('#pane5').addClass('active show');

        $('#heading5 button').removeClass('collapsed');
        $('#collapse5').addClass('show');
        
        $('#cazul').prop('checked', true);
        $('#cazul').prop('disabled', true);      
        $('#cazul').next('label').addClass('checked');
        
      }, 500);
    }
});
